
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D1ED7E","d":"M39.513 8.294a5.3 5.3 0 0 1 5.3 5.3v20.13a5.3 5.3 0 0 1-5.3 5.3H8.488a5.3 5.3 0 0 1-5.293-5.027l-.007-.272V13.594a5.3 5.3 0 0 1 5.3-5.3zM21.679 18.32a1.27 1.27 0 0 0-1.905 1.099v8.796a1.27 1.27 0 0 0 1.904 1.1l7.618-4.399a1.27 1.27 0 0 0 0-2.198z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M3.688 33.724v-20.13a4.8 4.8 0 0 1 4.8-4.8h31.024a4.8 4.8 0 0 1 4.8 4.8v20.13a4.8 4.8 0 0 1-4.8 4.8H8.488a4.8 4.8 0 0 1-4.8-4.8Z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M29.046 23.15a.77.77 0 0 1 0 1.333l-7.617 4.398a.77.77 0 0 1-1.155-.666V19.42a.77.77 0 0 1 1.154-.667z"}})])
          )
        }
      }
    